<template>
  <main>
    <footer class="bg-[#151515] text-white">
      <div class="py-8 md:px-12 p-4 max-w-screen-2xl mx-auto">
        <!-- Logo implementation -->
        <div class="flex justify-center items-center mt-4 mb-14">
          <img
            src="../assets/images/BM_White White.svg"
            alt="Barka logo"
            class="h-8 md:h-12"
          />
        </div>
        <div class="flex flex-wrap justify-between">
          <!-- Quick Links -->
          <div class="w-full lg:w-1/4 mb-6 lg:mb-0">
            <h5 class="font-bold mb-4">Quick Links</h5>
            <ul>
              <li>
                <a
                  href="https://mshelhomes.com/"
                  target="_blank"
                  class="hover:text-blue text-2xl transition-all duration-300"
                  >Mshel Homes</a
                >
              </li>
              <li>
                <a
                  href="https://lisasuites.com/"
                  target="_blank"
                  class="hover:text-blue text-2xl transition-all duration-300"
                  >Lisa Suites</a
                >
              </li>
              <!-- <li>
                <button @click="openModal" class="text-white text-2xl">
                  Download Newsletter
                </button>
              </li> -->
            </ul>
          </div>

          <!-- Resources -->
          <div class="w-full lg:w-1/4 mb-6 lg:mb-0">
            <h5 class="font-bold mb-4">Resources</h5>
            <ul>
              <li>
                <a
                  href="#"
                  target="_blank"
                  class="hover:text-blue text-2xl transition-all duration-300"
                  >Articles</a
                >
              </li>
              <li>
                <a
                  href="https://www.youtube.com/@barkaumshelia"
                  target="_blank"
                  class="hover:text-blue text-2xl transition-all duration-300"
                  >Videos</a
                >
              </li>
            </ul>
          </div>

          <!-- Information -->
          <div class="w-full lg:w-1/4 mb-6 lg:mb-0">
            <h5 class="font-bold mb-4">Information</h5>
            <ul>
              <li>
                <a
                  href="#"
                  target="_blank"
                  class="hover:text-blue text-2xl transition-all duration-300"
                  >Privacy Policy</a
                >
              </li>
              <li>
                <a
                  href="#"
                  target="_blank"
                  class="hover:text-blue text-2xl transition-all duration-300"
                  >Cookie Policy</a
                >
              </li>
              <li>
                <a
                  href="#"
                  target="_blank"
                  class="hover:text-blue text-2xl transition-all duration-300"
                  >Terms and Condition</a
                >
              </li>
              <li>
                <a
                  href="#"
                  target="_blank"
                  class="hover:text-blue text-2xl transition-all duration-300"
                  >Return & Refund Policy</a
                >
              </li>
              <li>
                <a
                  href="#"
                  target="_blank"
                  class="hover:text-blue text-2xl transition-all duration-300"
                  >Media Release Policy</a
                >
              </li>
            </ul>
          </div>

          <!-- Contact -->
          <div class="w-full lg:w-1/4">
            <h5 class="font-bold mb-4">Contact</h5>
            <ul>
              <li>
                <a href="mailto:info@barkaumshelia.com"
                  >info@barkaumshelia.com</a
                >
              </li>
              <li><a href="tel:+23470687793">+234 706 877 7793</a></li>
            </ul>
            <div class="flex space-x-4 mb-4 mt-4">
              <a
                href="https://www.facebook.com/barmshel?mibextid=LQQJ4d"
                target="_blank"
                class="hover:text-blue transition-all duration-300"
                ><i class="fa-brands fa-facebook-f"></i
              ></a>
              <a
                href="https://www.instagram.com/barkaumshelia?igsh=MW0xcDdrbmg1dnNpaQ%3D%3D&utm_source=qr"
                target="_blank"
                class="hover:text-blue transition-all duration-300"
                ><i class="fa-brands fa-instagram"></i
              ></a>
              <a
                href="https://youtube.com/@barkamshelia?si=LMpUZmOfBcS_DD9P"
                target="_blank"
                class="hover:text-blue transition-all duration-300"
                ><i class="fa-brands fa-youtube"></i
              ></a>
              <a
                href="https://www.linkedin.com/in/barka-mshelia-408232102?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                target="_blank"
                class="hover:text-blue transition-all duration-300"
                ><i class="fa-brands fa-linkedin-in"></i
              ></a>
            </div>
          </div>
        </div>
      </div>
      <div class="border-b border-[#f0f0f0] opacity-30"></div>
      <div class="bg-custom-blue-dark text-center">
        <p class="text-sm mt-1">
          Copyrights 2025 Barka Mshelia. All Rights Reserved
        </p>
      </div>
    </footer>
  </main>
</template>

<script>
import {
  showErrorAlert,
  showLoadingAlert,
  showSuccessAlert,
} from "../services/reusableService";
export default {
  name: "FooterSection",
  data() {
    return {
      isModalOpen: false,
      formData: {
        name: "",
        email: "",
      },
    };
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    resetForm() {
      this.formData = {
        name: "",
        email: "",
      };
    },
    async downloadFile(type) {
      if (!this.formData.name || !this.formData.email) {
        showErrorAlert("Kindly fill the form before you can download!");
        return;
      }

      const months = [
        "january",
        "february",
        "march",
        "april",
        "may",
        "june",
        "july",
        "august",
        "september",
        "october",
        "november",
        "december",
      ];
      const currentDate = new Date();
      const currentMonth = months[currentDate.getMonth()];
      const currentYear = currentDate.getFullYear();
      const fileName = `${currentMonth}-newsletter-${type}-${currentYear}.pdf`;
      const newsletterUrl = `https://mshelhomes.com/images/pdf/${fileName}`;

      try {
        showLoadingAlert("Preparing your download...");

        // Simulating a small delay for better UX
        setTimeout(() => {
          const a = document.createElement("a");
          a.href = newsletterUrl;
          a.target = "_blank";
          a.download = fileName;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          showSuccessAlert("Download started successfully!");
          this.resetForm();
          this.closeModal();
        }, 1000);
      } catch (error) {
        showErrorAlert("Failed to start download. Please try again!");
      }
    },
  }
};
</script>

<style scoped>
.text-sm {
  font-size: 10px !important;
}
</style>
